import { render } from "./CardGridComponent.vue?vue&type=template&id=07801c3f&scoped=true"
import script from "./CardGridComponent.vue?vue&type=script&lang=js"
export * from "./CardGridComponent.vue?vue&type=script&lang=js"

import "./CardGridComponent.vue?vue&type=style&index=0&id=07801c3f&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07801c3f"]])

export default __exports__